import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE012_Request,
  IAPI_PRE012_Response,
} from "../../../type/apiType";

// 施設の登録内容の確認表示
// API仕様書_掛金
const httpAPI_PRE012 = async (
  param: IAPI_PRE012_Request
): Promise<IAPI_PRE012_Response> => {
  let res = await http.post(ApiUrl.API_PRE012, {
    ...param,
  });

  return res.data;
};

export { httpAPI_PRE012 };
